import { Component, Output, Input, EventEmitter } from '@angular/core';
import { Question } from '../../model/question';
import { Constants } from '../../model/constants';
import {Choice} from '../../model/choice';


@Component({

    selector: 'create-question-dialog',
    styles: [
        `            .TextLabel,.QuestionTextInput{margin-top: 5px;}
    .modal-dialog {
        width: 50%;
        margin:  auto;
    }
    .modal-header{
        background-color:dodgerblue;
        color:antiquewhite;
    }
    .closeX{color:azure;size:25px;}
    .closeX{background-color: red;height:60px;width:60px;z-index: +1;}
    .questionWindow{ height:35px;}
    .btn-danger{background-color: red;border-style: solid;border-color: white;border-width:2px;}
        `
    ],
    template: `<div class="modal" [style.display]="hide ? 'none' : 'inline'" style="margin : 20px; ">
    <div class="modal-dialog" *ngIf="question != null">
        <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <img class="questionWindow" src="../../../assets/images/168.png">
              <h5 class="modal-title">Add Question</h5>
              <button (click)="hideDialog();" type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close">
                  <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
              </button>
            </div>
            <form accept-charset="UTF-8" name="form" (ngSubmit)="f.form.valid && newQuestion() " #f="ngForm" novalidate>
                <div class="modal-body">
                            <div class="row " style="margin-top:20px; ">
                                <div class="col-md-2">
                                    <div style="margin-top: 10px;margin-bottom: 10px;">
                                        <label>Options</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="checkbox checkbox-primary">
                                        <label>
                                            <input type="checkbox" checked [(ngModel)]="question.mandatory" name="mandatoryCheckBox"/>Mandatory
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="checkbox checkbox-primary">
                                        <label>
                                            <input type="checkbox" checked [(ngModel)]="question.recyclable" name="recyclableCheckBox"/>Recyclable
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="checkbox checkbox-primary">
                                        <label>
                                            <input type="checkbox" checked [(ngModel)]="question.toSave" name="toSaveCheckBox"/>To Save
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="checkbox checkbox-primary">
                                        <label>
                                            <input type="checkbox" checked [(ngModel)]="question.visible" name="visibleCheckBox"/>Visible
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- type Question -->
                            <div class="row " style="margin-top:20px; ">
                                <div class="col-md-2">
                                    <label>Type</label>
                                </div>
                                <div class="col-md-10">
                                    <select class="form-control" name="typeQuestion" #l [(ngModel)]="question.type">
                                        <option *ngFor="let type of  this.constants.QUESTION_TYPES" [value]="type.value">
                                            {{type.display}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div  *ngIf='question.type === "dynamic"' class="row " style="margin-top:20px; ">
                              <div class="col-md-2">
                                <label>Tag</label>
                              </div>
                              <div class="col-md-10">
                                <select class="form-control" name="typeQuestion" [(ngModel)]="question.tag">
                                  <option *ngFor="let tag of  _question_tags" [value]="tag.value">
                                    {{tag.display}}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <!-- Texts -->
                            <div class="row" style="margin-top:20px;">
                                <div class="col-md-2">
                                    <label class="TextLabel">Texts : </label>
                                </div>
                                <div class="col-md-10">
                                    <input  *ngFor="let lg of languages;" type="text" class="form-control QuestionTextInput" name="textsQuestion{{lg}}" placeholder="Text {{lg}} ..." [ngModel]="question.texts.get(lg)" (ngModelChange)="updateInput($event,lg)">
                                </div>
                            </div>
                    </div>
                <!-- footer-->
                <div class="modal-footer ">
                  <button class="btn btn-primary clickable hand" id="submit" type="submit">Add</button>
                </div>
            </form>
        </div>
    </div>
</div>`
})
export class CreateQuestionComponent {

    @Input('languages') languages: string[];
    @Input('question') question: Question;
    private hide = true;
    @Output() OnNewQuestion: EventEmitter<any> = new EventEmitter();
    @Output() OnCancelQuestion: EventEmitter<any> = new EventEmitter();

    private _question_tags;

    constructor(private constants: Constants) {

        this._question_tags = constants.QUESTION_TAGS;
    }

    hideDialog() {
        this.OnCancelQuestion.emit();
    }

    newQuestion() {
        this.question.clazz = this.constants.QUESTION_TYPES_TO_CLAZZ[this.question.type];

        /*if(this.question.type !== 'combo') {
          const choice = new Choice();
          choice.no = 1;
          choice.clazz = this.constants.CHOICE_TYPES_TO_CLAZZ[this.question.type];
          this.question.choices.push(choice);
        }*/

        this.OnNewQuestion.emit(this.question);
    }

    public toggle() {
      this.hide = !this.hide;
    }

  updateInput(val: any, lang: string) {
      this.question.texts.set(lang,val);
  }
}
